import { useOrgRole } from '@/hooks/use-org-role';

export function useGHGRole() {
  const { role, isAdmin, isLoading } = useOrgRole();

  const isManager = isAdmin || role === 'manager';

  return { orgRole: role, isAdmin, isManager, isLoaded: !isLoading };
}
